export default __webpack_public_path__ + "static/media/success.5eebcf14.svg";